import React, { useEffect, useState } from "react";
import { FC } from "react";

// DEMO DATA

export interface OptionSelectProps {
  onChange?: (data: string) => void;
  defaultValue?: string;
  categories: string[];
}

const OptionSelect: FC<OptionSelectProps> = ({
  onChange,
  defaultValue,
  categories,
}) => {
  const [category, setCategory] = useState("Todos");

  useEffect(() => {
    if (!defaultValue) return;
    setCategory(defaultValue);
  }, [defaultValue]);
  
  return (
    <div className="p-5">
      <div className="relative flex flex-col space-y-5 mt-7">
        {categories.map((item, index) => (
          <div className="flex items-center">
            <input
              defaultChecked={item===category}
              checked={item===category}
              id={item}
              name={item}
              type="radio"
              onChange={(e) => {
                setCategory(item);
                onChange && onChange(item);
              }
              }
              className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
            />
            <label
              htmlFor={item}
              className="ml-3 block text-sm font-medium text-neutral-700 dark:text-neutral-300"
            >
              {item}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OptionSelect;
